import { useTranslation } from "react-i18next";
import { IconButton, Tooltip, makeStyles } from "@material-ui/core";
import BugReportIcon from "@material-ui/icons/BugReport";
import FileCopyOutlinedIcon from "@material-ui/icons/FileCopyOutlined";
import {
  PropertyData,
  PropertyLabel,
} from "components/EmailEventDetails/styled";
import useClipboard from "utils/useClipboard";
import { MalwareEvent } from "@dashboard-v3/api";

interface Props {
  event: MalwareEvent;
}

export default function MalwareDetails({ event }: Props) {
  const { checksum, threats } = event.data;
  const { t } = useTranslation("userActivity");
  const copyToClipboard = useClipboard();
  const classes = useStyles();

  return (
    <div className={classes.malware}>
      <div>
        <PropertyLabel>{t("details.threat")}</PropertyLabel>
        <PropertyData color="textPrimary" className={classes.threat}>
          <BugReportIcon fontSize="small" className={classes.threatIcon} />
          {threats.join(", ")}
        </PropertyData>
      </div>
      <div>
        <PropertyLabel>{t("details.checksum")}</PropertyLabel>
        <PropertyData color="textPrimary" className={classes.checksum}>
          <Tooltip title={checksum}>
            <span className={classes.checksumValue}>{checksum}</span>
          </Tooltip>
          <Tooltip title={t("details.copy")}>
            <IconButton
              size="small"
              data-testid="copy-btn"
              className={classes.copy}
              onClick={() => copyToClipboard(checksum)}
            >
              <FileCopyOutlinedIcon fontSize="inherit" />
            </IconButton>
          </Tooltip>
        </PropertyData>
      </div>
    </div>
  );
}

const useStyles = makeStyles(theme => ({
  malware: {
    display: "flex",
    flexDirection: "column",
    gap: 14,
    margin: "24px 0 4px",
    padding: "14px 16px",
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 8,
    backgroundColor: "#fafbfc",
  },
  threat: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    fontWeight: 500,
  },
  threatIcon: { color: "#b3261e", flexShrink: 0 },
  checksum: {
    display: "flex",
    alignItems: "center",
    gap: 6,
    fontFamily: "SFMono-Regular, Consolas, Menlo, monospace",
    fontSize: "0.8rem",
  },
  checksumValue: {
    minWidth: 0,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  copy: { flexShrink: 0 },
}));
